import { Visible, Hidden } from '@leroy-merlin-br/backyard-react-ui'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import CallCenterContent from './CallCenterContent'

export const CallCenterContentDesktop = (props) => (
  <ContextVisibility when={['ecommerce']}>
    <Hidden untilKilo kilo>
      <CallCenterContent {...props} />
    </Hidden>
  </ContextVisibility>
)

export const CallCenterContentResponsive = (props) => (
  <ContextVisibility when={['ecommerce']}>
    <Visible untilKilo kilo>
      <CallCenterContent {...props} />
    </Visible>
  </ContextVisibility>
)

export const CallCenterContentMobile = (props) => (
  <ContextVisibility when={['app']}>
    <Visible untilKilo kilo>
      <CallCenterContent {...props} />
    </Visible>
  </ContextVisibility>
)
